import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom"
import { action } from "../../context/action";
import { CurrentTime } from "../../funcs/current";
import { CheckUser } from "../../funcs/validateEmp";
import { mainSearch, recodeNow, update } from "../indexDB/indexDBStora";
import Empty from "../empPage/empty";
import { useTransaction } from "../../funcs/hooks/usetransaction";
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from "react-i18next";
import { auth } from "../../context/auth";


export default function Expenses( props ) {
    const CODE = useParams().username || "";
    const navigate = useNavigate();
    const { user } = useContext(auth);
    const { t } = useTranslation();

    const {setErrorMessage} = useContext(action);
    const [userExp, setUserExp] = useState([]);
    const initexpense = {
        value:0,
        reason:"",
        date:""
    }
    const [expense, setExpense] = useState(initexpense);
        
    const Reset = () => {
        navigate("/employees", {replace : true});
        setExpense(initexpense);
        setUserExp([])
        return;
    }

    useEffect(() => {
        const Check = async () => {
            const getUser = await CheckUser(CODE);
            if(!getUser.status) {
                Reset();
                return;
            }
            setUserExp(getUser.data.expenses);
        }

        if(props.path === 'exp') {
            Check();
        }

    }, [CODE, props.path])

    const totalPrice = useMemo(() => {      
      return userExp.reduce((total, item) => {
      return total + Number(item.value);
    }, 0);
  }, [userExp]);

    const record_transaction = useTransaction("record", "" , true);

    const AddExpense  = async (e) => {
        e.preventDefault();
        if(!CODE) {
            setErrorMessage("اضغط على سلف للموظف المراد");
            return;
        }
        if(expense.value <= 0) {
            setErrorMessage("ادخل قيمة السلفة بشكل صحيح");
            return;
        }

        const USER = await mainSearch("employees", CODE);

        expense.id = uuidv4();
        expense.date = CurrentTime();

        USER.expenses.push(expense)

        await update("employees", USER)
        record_transaction.data.message = `تم استلاف من مبلغ ${expense.value} جنيه و السبب هو ${expense.reason}`;

        await recodeNow(record_transaction.data, "transactions");
        Reset();
    }

    return (
        props.path === 'exp' ?
        <div>
            <form onSubmit={AddExpense}>
                <div className="flex">
                    <div className="child">
                        <label>{t("common:code")}</label>
                        <input disabled value={CODE} type="text" placeholder="USERNAME" />
                    </div>
                    <div className="child">
                        <label>{t("label:expenses.expense")}</label>
                        <input 
                        value={expense.value}
                        onChange={(e) => setExpense((prev) => ({...prev, value: e.target.value}))} min={1} type="number" placeholder="ادخل قيمة السلفة" />
                    </div>
                    <div className="child">
                        <label>{t("common:reason")}</label>
                        <input 
                        value={expense.reason}
                        onChange={(e) => setExpense((prev) => ({...prev, reason: e.target.value}))}
                        type="text" placeholder="سبب السلفة" />
                    </div>
                </div>
               <div className="flex btns">
                    <button className="success-bg">{t("action:expense")}</button>
                    {CODE &&
                        <button type="button" onClick={() => Reset()} className="error text-weight-bold">X</button>
                    }
               </div>
            </form>
            <h3 className="right">{t("common:pos.total")} {t("common:expenses")} {totalPrice} {user.data[0].currency.symbol}</h3>
            <div className="table">
                <table>
                <thead>
                    <tr>
                        <th>{t("common:value")}</th>
                        <th>{t("common:reason")}</th>
                        <th>{t("common:date")}</th>
                    </tr>
                </thead>
                <tbody>
                    {
                    userExp.length !== 0 &&
                    userExp.map((e, i) =>
                        <tr key={i}>
                            <td>{e.value} {props.currency}</td>
                            <td>{e.reason || "?"}</td>
                            <td>{e.date}</td>
                        </tr>
                    )}
                </tbody>
                </table>
            </div>
        </div>
        :
        <Empty mode="employee" />
    )
}